<template>
    <div class="form-search">
      <svg class="form-search__icon" width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill="#DA2D8A" fill-rule="evenodd" clip-rule="evenodd" d="M12.7395 12.1667L16.4895 15.9167C16.8229 16.25 16.8229 16.75 16.4895 17.0834C16.3229 17.25 16.0729 17.3334 15.9062 17.3334C15.7395 17.3334 15.4895 17.25 15.3229 17.0834L11.5729 13.3334C10.3229 14.25 8.82288 14.8334 7.15621 14.8334C3.23954 14.8334 0.072876 11.6667 0.072876 7.75002C0.072876 3.83335 3.23954 0.666687 7.15621 0.666687C11.0729 0.666687 14.2395 3.83335 14.2395 7.75002C14.2395 9.41669 13.6562 11 12.7395 12.1667ZM7.15621 2.33335C4.15621 2.33335 1.73954 4.75002 1.73954 7.75002C1.73954 10.75 4.15621 13.1667 7.15621 13.1667C8.65621 13.1667 9.98954 12.5834 10.9895 11.5834C11.9895 10.5834 12.5729 9.25002 12.5729 7.75002C12.5729 4.75002 10.1562 2.33335 7.15621 2.33335Z" />
      </svg>

      <vs-input
        class="w-full form-search__input"
        @input="onChange"
        v-model="value"
        :placeholder="placeholder"
      />

      <svg v-show="value.length !== 0" @click="onClear" class="form-search__clear" width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.9896 10.4167C12.3229 10.75 12.3229 11.25 11.9896 11.5834C11.8229 11.75 11.6563 11.8334 11.4063 11.8334C11.1563 11.8334 10.9896 11.75 10.8229 11.5834L6.40626 7.16669L1.98959 11.5834C1.82292 11.75 1.65626 11.8334 1.40626 11.8334C1.15626 11.8334 0.989588 11.75 0.822922 11.5834C0.489588 11.25 0.489588 10.75 0.822922 10.4167L5.23959 6.00002L0.822922 1.58335C0.489588 1.25002 0.489588 0.75002 0.822922 0.416687C1.15626 0.0833537 1.65626 0.0833537 1.98959 0.416687L6.40626 4.83335L10.8229 0.416687C11.1563 0.0833537 11.6563 0.0833537 11.9896 0.416687C12.3229 0.75002 12.3229 1.25002 11.9896 1.58335L7.57292 6.00002L11.9896 10.4167Z" fill="black"/>
      </svg>
    </div>
</template>

<script>

import { debounce } from 'lodash'

export default {
    name: "SearchInput",
    props: {
      defaultValue: String,
      placeholder: String,
    },
    data() {
      return {
        value: this.defaultValue || "",
      };
    },

    watch: {
      value() {
        this.$emit("input", this.value);
      },
	  defaultValue() {
		this.value = this.defaultValue;
	  }
    },

    methods: {
      onChange: debounce(function(e) {
        this.$emit("onChange", this.value)
      }, 300),

      onClear() {
        this.value = "";
        this.$emit("onChange", this.value)
      }
    }
};
</script>

<style lang="scss">
.form-search {
  position: relative;
  box-shadow: 0 1px 15px 1px rgba(var(--vs-dark), 0.1);
  border-radius: 3px;
  
  .form-search__icon {
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
    z-index: 100;
  }
  
  .form-search__input {

    .vs-con-input {
      .vs-input--input {
        padding: 1rem !important;
        padding-left: 45px !important;
        border: 0 !important;
      }

      .vs-input--placeholder, .input-span-placeholder, .input-span-placeholder.vs-input--placeholder {
        transform: translate(0, 0)!important;

        padding-left: 45px !important;
        top: 8%;
        font-size: 12px;
        color: #BABFC7;
        font-weight: 500;
        font-size: 14px;

      }
    }

    &.isFocus {
      .vs-con-input {
        .vs-input--input:focus {
          border: 0!important;
          box-shadow: 0 0 0 #fff;
        }

        .vs-input--input:focus + .vs-input--placeholder {
          display: none;
        }
      }
    }
  }

  .form-search__clear {
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
    cursor: pointer;
    path {
      fill: #6E6B7B;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Input/SearchInput.vue